export default __webpack_public_path__ + "images/82ae6eee7cc7c8b635f67ebeaca7cbe5-emoji-depressed.svg";